import React from "react";
import { Button, Typography } from "antd";
import { Link } from "react-router-dom";

const { Title, Paragraph } = Typography;

export default function CancellationPolicy() {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(to bottom right, #0a0a0a, #1a1a2e)",
        color: "#fff",
        padding: "80px 24px 40px",
        maxWidth: 720,
        margin: "0 auto",
      }}
    >
      <Link to="/">
        <Button type="link" style={{ color: "#fc8c02", paddingLeft: 0 }}>
          Back to scheduling
        </Button>
      </Link>
      <Title level={2} style={{ color: "#fff", marginTop: 16 }}>
        No-Show and Cancellation Policy
      </Title>
      <Paragraph style={{ color: "rgba(255,255,255,0.9)" }}>
        To help us offer appointments fairly and efficiently to all patients, we
        require at least 48 business hours&apos; notice for any cancellation or
        request to reschedule an appointment.
      </Paragraph>
      <Paragraph style={{ color: "rgba(255,255,255,0.9)" }}>
        If you cancel, reschedule, or fail to attend your appointment with less than
        48 business hours&apos; notice, you will be charged the full cost of the
        scheduled appointment. Because appointment fees vary, the charge will be
        based on the full price of the visit you reserved.
      </Paragraph>
      <Paragraph style={{ color: "rgba(255,255,255,0.9)" }}>
        Business hours do not include weekends or office closures. Requests made
        after business hours will be considered received on the next business day.
      </Paragraph>
      <Paragraph style={{ color: "rgba(255,255,255,0.9)" }}>
        Appointments may be moved without penalty only when the request is made
        more than 48 business hours in advance. If the request is made within 48
        business hours, the appointment payment may be forfeited and a new payment
        may be required to reschedule.
      </Paragraph>
      <Paragraph style={{ color: "rgba(255,255,255,0.9)" }}>
        Exceptions for true emergencies may be considered on a case-by-case basis.
      </Paragraph>
      <Paragraph style={{ color: "rgba(255,255,255,0.9)" }}>
        To cancel or request a reschedule, please contact Texas Center Wellness at{" "}
        <a href="tel:5129570001" style={{ color: "#fc8c02" }}>
          512-957-0001
        </a>
        .
      </Paragraph>
    </div>
  );
}
